import React, { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../thoughts/chat/RenderResponse";
import { useParams } from "react-router-dom";
import { getPodcastCitationInfo } from "../../api/axiosApi";
import { Tooltip } from "@material-tailwind/react";
import Avatar from "../../design-system/Avatar";
import { getInitials } from "../../utils/common";

// // Define types for your props
// interface Citation {
//     link: string;
// }

// interface PodcastViewerProps {
//     podcastText?: string;
//     citation: Citation;
// }

export type PodcastIntoType = {
    filename: string;
    date: string;
    link: string;
    media_type: string;
    podcast_summary?: string;
    text?: string;
    title?: string;
};

// interface PodcastViewerProps {
//   PodcastIntoType: PodcastIntoType;
// }

const PodcastViewer = () => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [showDivider, setShowDivider] = useState(false);
    const [podcastInfo, setPodcastInfo] = useState<PodcastIntoType>();
    const [podcastError, setPodcastError] = useState();
    const { podcast_citation } = useParams();

    async function fetchPodcastInfo() {
        try {
            const seedFileData = await getPodcastCitationInfo(podcast_citation + ".txt");
            const podcastData = await seedFileData.data;
            console.log();
            if (podcastData.status === "success") {
                // const cleanedText = podcastData.podcast_info.podcast_summary.replace(/\s*\[Host Name\]/g, " PM-Power Consulting").replace(/\\n/g, "\n");
                setPodcastInfo(podcastData.podcast_info);
            } else if (podcastData.status === "error") {
                setPodcastError(podcastData?.message);
            }
        } catch (error: any) {
            console.error(`Failed to fetch source info `, error);
            // setPodcastError(error.message); // Set error message when request fails
        } finally {
            // setIsLoading(false);
        }
    }
    useEffect(() => {
        fetchPodcastInfo();
    }, []);

    function decodeUnicode(input: string): string {
        return input.replace(/\\u[\dA-Fa-f]{4}/g, match => String.fromCharCode(parseInt(match.replace("\\u", ""), 16)));
    }
    return (
        <div className=" h-full pb-28">
            {podcastInfo ? (
                <>
                    <div className="py-2 text-2xl text-green-800 sticky top-0  flex  ">
                        <div className="">
                            <Tooltip
                                content="Software People Stories"
                                className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50"
                                placement="right"
                            >
                                <div>
                                    <Avatar initials={getInitials("Software People Stories")} className="mr-2" />
                                </div>
                            </Tooltip>
                        </div>
                        <div className=" flex justify-center w-full ">{podcastInfo.title}</div>
                    </div>

                    <div ref={containerRef} className="flex-1 h-full overflow-auto bg-white p-3 w-full pr-2 rounded-md">
                        <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} components={markdownComponents}>
                            {decodeUnicode(podcastInfo.podcast_summary?.replace(/\\n/g, "\n") || "")}
                        </ReactMarkdown>
                    </div>

                    <div className="pt-2 sticky bottom-0 z-10 flex justify-center ">
                        <p className="font-medium text-green-800">Listen to the podcast:</p>&nbsp;
                        <a href={podcastInfo.link} target="_blank" rel="noopener noreferrer" className="cursor-pointer  hover:underline  text-blue-700 ">
                            {podcastInfo.link}
                        </a>
                    </div>
                    <div className=" px-2 text-center	">
                        <span className="inline-block card_text_color text-sm">
                            <strong>Important:</strong>&nbsp;This summary is automatically generated using AI and may not reflect the full content of the
                            podcast.
                        </span>
                    </div>
                </>
            ) : (
                <div className="flex h-full justify-center items-center p-12 text-2xl">{podcastError}</div>
            )}
        </div>
    );
};

export default PodcastViewer;
